import { query } from './api';
import {
  addSupportCaseCommentQuery,
  closeSupportCaseQuery,
  findSupportCaseQuery,
  getSupportCaseListQuery,
  hasSupportCaseQuery,
} from './support-case.query';
import SupportCase, { HasSupportCases, SupportCaseSuccess } from './support-case.types';

interface SupportCaseApiInterface {
  get(billingCustomerId: string): Promise<SupportCase[]>;
  hasCases(billingCustomerId: string): Promise<HasSupportCases>;
  find(billingCustomerId: string, reference: string): Promise<SupportCase>;
  addComment(billingCustomerId: string, reference: string, message: string): Promise<SupportCaseSuccess>;
  close(billingCustomerId: string, reference: string): Promise<SupportCaseSuccess>;
}

const SupportCaseApi: SupportCaseApiInterface = {
  async get(billingCustomerId: string): Promise<SupportCase[]> {
    const response = await query<{ getSupportCaseList: SupportCase[] }>({
      query: getSupportCaseListQuery,
      variables: { billingCustomerId },
      name: 'getSupportCaseList',
    });

    return response.getSupportCaseList;
  },

  async hasCases(billingCustomerId: string): Promise<HasSupportCases> {
    const response = await query<{ hasSupportCase: HasSupportCases }>({
      query: hasSupportCaseQuery,
      variables: { billingCustomerId },
      name: 'hasSupportCase',
    });

    return response.hasSupportCase;
  },

  async find(billingCustomerId: string, reference: string): Promise<SupportCase> {
    const response = await query<{ findSupportCase: SupportCase }>({
      query: findSupportCaseQuery,
      variables: {
        billingCustomerId,
        reference,
      },
      name: 'findSupportCase',
    });

    return response.findSupportCase;
  },

  async addComment(billingCustomerId: string, reference: string, message: string): Promise<SupportCaseSuccess> {
    const response = await query<{ addSupportCaseComment: SupportCaseSuccess }>({
      query: addSupportCaseCommentQuery,
      variables: {
        billingCustomerId,
        reference,
        message,
      },
      name: 'addSupportCaseComment',
    });

    return response.addSupportCaseComment;
  },

  async close(billingCustomerId: string, reference: string): Promise<SupportCaseSuccess> {
    const response = await query<{ closeSupportCase: SupportCaseSuccess }>({
      query: closeSupportCaseQuery,
      variables: {
        billingCustomerId,
        reference,
      },
      name: 'closeSupportCase',
    });

    return response.closeSupportCase;
  },
};

export default SupportCaseApi;
